import Vue from 'vue'

export const EVENTS = {
  WEBSITE_PAGE_ADDED: 'website-page-added'  
}

const eventBus = new Vue()

export default eventBus
